import React from 'react';
import { RouteProps, useNavigate } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';

// inspired by: https://auth0.com/blog/complete-guide-to-react-user-authentication/
const Auth0ProviderWithHistory: React.FC<RouteProps> = ({ children }) => {
  const domain = process.env.REACT_APP_AUTH0_DOMAIN || '';
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID || '';
  const redirectUri = `${window.location.origin}/dashboard/client-list`;
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE;

  const navigate = useNavigate();

  const onRedirectCallback = (appState: any) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      redirectUri={redirectUri}
      onRedirectCallback={onRedirectCallback}
      audience={audience}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
